import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Box,
  Typography,
  Container,
  Card,
  CardContent,
} from "@material-ui/core";
import Page from "src/components/Page";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import KmFilteredTable from "src/components/common/KmFilteredTable";
import { apiEndpoints, apiGetRequest } from "src/utils/api/api";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import KmPageTitle from "src/components/layout/KmPageTitle";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  massagebox: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  title: {
    marginLeft: theme.spacing(3.5),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    flexGrow: 1,
  },
}));

const LoggedInUsers = ({ enableGlobalLoader, disableGlobalLoader }) => {
  const classes = useStyles();

  const [votingMembers, setVotingMembers] = useState([]);
  const [votingMembersTotal, setVotingMembersTotal] = useState(0);
  const [reloadCounter, setReloadCounter] = useState(0);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    enableGlobalLoader();
    apiGetRequest(apiEndpoints.getLoggedInUsers.path, true)
      .then((data) => {
        disableGlobalLoader();
        setVotingMembers(data.votingMembers);
        setVotingMembersTotal(data.votingMembersTotal);
      })
      .catch((error) => {
        disableGlobalLoader();
      });
    return () => {};
  }, [reloadCounter]);

  const headCells = [
    {
      id: "name",
      numeric: false,
      disablePadding: true,
      fieldName: "name",
      sortable: true,
      main: true,
      label: "Nazwa instytucji",
    },
    {
      id: "users",
      fieldName: "users",
      numeric: false,
      disablePadding: false,
      sortable: true,
      searchable: true,
      label: "Zalogowani użytkownicy",
    },
  ];

  return (
    <Page
      className={classes.root}
      title="Administracja - Zalogowani użytkownicy"
    >
      <KmPageTitle>Zalogowani użytkownicy</KmPageTitle>
      <Container maxWidth={false}>
        <Card>
          <CardContent>
            <Typography variant="h4" component="h2">
              Aktualna liczba zalogowanych Członków KM / Zastępców Członka KM z prawem głosowania:{" "}
              {votingMembersTotal}
            </Typography>
            <Box mt={3}>
              <KmFilteredTable
                markable={false}
                headCells={headCells}
                rows={votingMembers}
              />
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
};

const mapDispatchToProps = (dispatch) => ({
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
});

export default connect(null, mapDispatchToProps)(LoggedInUsers);
